import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';

interface Props {
    position: number;
    optionNumber?: number;
    showCheckbox?: boolean;
}
export function OtherOptionPreview({ position, optionNumber, showCheckbox = false }: Props) {
    const checkbox = (
        <Radio
            id={`${position || ''}-other-option`}
            name={''}
            sx={{
                '&.Mui-disabled': {
                    color: '#333 !important',
                    paddingLeft: 0,
                },
            }}
            disabled
        />
    );
    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            {showCheckbox ? checkbox : null}
            <TextField
                disabled
                variant="filled"
                label={`Option ${optionNumber || 1}`}
                value={`"Free Form" response`}
                sx={{ marginBottom: '1rem', width: '100%' }}
            />
        </div>
    );
}
